
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

const dayNames = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];

type AvailabilityDaySelectorProps = {
  selectedDay: number | null;
  onDaySelect: (day: number) => void;
  scheduledDays: number[];
};

const AvailabilityDaySelector = ({
  selectedDay,
  onDaySelect,
  scheduledDays
}: AvailabilityDaySelectorProps) => {
  
  const getDayStatusIcon = (day: number) => {
    if (scheduledDays.includes(day)) {
      return <CheckCircle className="w-4 h-4 text-green-500" />;
    }
    return null;
  };

  return (
    <Card className="lg:col-span-2 bg-gradient-to-b from-[#1E293B] to-[#1A212E] border-[#2A3749] shadow-xl backdrop-blur-sm">
      <CardHeader className="pb-4">
        <CardTitle className="text-white text-xl">Selecione o Dia</CardTitle>
        <CardDescription className="text-gray-400">Escolha um dia para configurar</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <ToggleGroup 
            type="single" 
            value={selectedDay !== null ? selectedDay.toString() : undefined}
            onValueChange={(value) => value && onDaySelect(parseInt(value, 10))}
            className="flex flex-col w-full gap-2"
          >
            {dayNames.map((day, index) => (
              <ToggleGroupItem 
                key={index} 
                value={index.toString()} 
                variant="custom"
                size="xl"
                className="w-full justify-between px-4 group transition-all duration-200"
              >
                <span>{day}</span>
                {getDayStatusIcon(index)}
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
        </div>
      </CardContent>
    </Card>
  );
};

export default AvailabilityDaySelector;
